var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"root"}},[_c(_vm.view,{tag:"component",class:{ "k-bottom": _vm.view !== "ValidacionInicial" }})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }